import { Dialog, Sheet } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import { useMemo } from 'react';

/** Возвращает элемент Dialog или Sheet, в зависимости от экрана Десктоп / Мобильный */
export const useCrossPopup = () => {
  const isMobile = useIsMobile();
  return useMemo(() => (isMobile ? Sheet : Dialog), [isMobile]);
};
